import { render, staticRenderFns } from "./Soon.vue?vue&type=template&id=66d75f34"
import script from "./Soon.vue?vue&type=script&lang=js"
export * from "./Soon.vue?vue&type=script&lang=js"
import style0 from "./Soon.vue?vue&type=style&index=0&id=66d75f34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports